import * as ConsentActions from './consent-actions';
import * as ConsentReducer from './consent-reducer';

export {
    ConsentActions,
    ConsentReducer
};
